import React from 'react';
import AnchorLink from "./AnchorLinkComponent";

class DelaCardComponent extends React.Component {

    constructor(props) {
        super(props);

        this.gotoLink = this.gotoLink.bind(this);
    }

    gotoLink() {
        this.props.history.push(this.props.pushTo);
    }

    render() {

        var cardStyle = {
            backgroundColor: "#EEE",
            padding: 0,
            height: "100%",
            width: parseInt(this.props.width, 10)
        }

        var delaCardContentStyle = {
            padding: 5
        }

        var delaCardTitleStyle = {
            fontSize: 20,
            fontWeight: "bold",
            color: "#333",
            marginBottom: 4,
            fontFamily: "Muli",
            textTransform: "uppercase",
        }

        var delaCardSubtitleStyle = {
            color: "#333",
            fontFamily: "Fira Sans"
        }

        var delaCardDescriptionStyle = {
            fontSize: 14,
            color: "#333",
            fontFamily: "Fira Sans",
            wordWrap: "break-word"
        }

        var delaCardDetailsStyle = {
            fontSize: 14,
            color: "#333",
            fontFamily: "Fira Sans",
        }

        return (
            <div style={cardStyle}>
                <img alt="" src={this.props.image}/>
                <br/>
                <div style={this.props.style.content}>
                    <p style={this.props.style.title}>{this.props.title}</p>
                    <p style={this.props.style.subtitle}>{this.props.subtitle}</p>
                    <p style={this.props.style.description}>{this.props.description}</p>
                    <AnchorLink value="details" style={this.props.style.detail.anchor} pushTo={this.props.pushTo}/>
                </div>
            </div>
        );
    }
}

export default DelaCardComponent


// WEBPACK FOOTER //
// src/components/DelaCardComponent.js